import { ReactComponent as Success } from '@basqet-dashboard/common/assets/icons/success.svg';
import { Button } from '@basqet-dashboard/common/components/';
import { formatCryptoCurrency, formatWallet, useNavigateTo } from '@basqet-dashboard/common/utils';
import { useFetchBeneficiaries, useFetchPayoutWallets } from '@hooks/queries';
import { SingleBeneficiaryModal } from '@pages/beneficiary';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const PayoutSuccessView = ({ transactionDetails }) => {
  const { navigateTo } = useNavigateTo();

  const { refetch: refetchPayoutWallets } = useFetchPayoutWallets();

  const { beneficiaries } = useFetchBeneficiaries({ singles_only: true, grouped: false });

  const [openBeneficiaryModal, setOpenBeneficiaryModal] = useState(false);
  const [isBeneficiarySaved, setIsBeneficiarySaved] = useState(false);
  const { currency_id, network, address } = transactionDetails;
  const beneficiaryInfo = { currency_id, network, wallet_address: address };

  const onModalClose = () => {
    setOpenBeneficiaryModal(false);
    setIsBeneficiarySaved(true);
  };

  useEffect(() => {
    const beneficiaryExists = beneficiaries.find((beneficiary) => beneficiary.address === address);

    refetchPayoutWallets();
    if (beneficiaryExists) {
      setIsBeneficiarySaved(true);
    } else {
      setIsBeneficiarySaved(false);
    }
  }, [beneficiaries]);

  return (
    <>
      <div className="card">
        <div className="process-info">
          <Success role="img" />
          <h3>Successful!</h3>
          <p className="card__text">
            You have successfully sent {formatCryptoCurrency(transactionDetails.amount)}{' '}
            {transactionDetails.currency_slug} to {formatWallet(transactionDetails.address)}
          </p>
        </div>
        <div className="payout__next__actions">
          <Button isFull type="submit" onClick={() => navigateTo('/payouts')}>
            Back to Dashboard
          </Button>
          {!isBeneficiarySaved && (
            <Button
              onClick={() => setOpenBeneficiaryModal(true)}
              isFull
              type="submit"
              variant="outline">
              Add to Beneficiaries
            </Button>
          )}
        </div>
      </div>
      {openBeneficiaryModal && (
        <SingleBeneficiaryModal beneficiary_info={beneficiaryInfo} onModalClose={onModalClose} />
      )}
    </>
  );
};

PayoutSuccessView.propTypes = {
  transactionDetails: PropTypes.object
};

export { PayoutSuccessView };
